var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9256 0L4.73467 3.76278e-07L0 8.19324L2.95768 13.3095C3.13657 13.071 3.33932 12.8444 3.55399 12.6297L1.0018 8.20517L5.23557 0.858681H25.4366L25.8063 1.49076C25.9852 1.21646 26.1522 0.95409 26.3191 0.67979L25.9256 0Z",
    fill: "url(#paint0_linear_11209_13243)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3207 1.89453C27.1537 2.16883 26.9868 2.44313 26.8079 2.72936L29.1812 6.79616L24.9474 14.1426H5.23545C5.02078 14.4289 4.79419 14.7151 4.55566 15.0013H25.4364L30.1711 6.80808L27.3207 1.89453Z",
    fill: "url(#paint1_linear_11209_13243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11209_13243",
    x1: 5.26805,
    y1: 0.00123313,
    x2: 5.26805,
    y2: 13.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11209_13243",
    x1: 42.3795,
    y1: 1.89453,
    x2: 42.3795,
    y2: 15.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17500D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemNumber);
export default __webpack_public_path__ + "static/media/item_number.61c73f6cc6c0b06f2bd74525e201402e.svg";
export { ForwardRef as ReactComponent };